import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { ApiService } from '../core/api.service';
import { AuthService } from '../core/auth.service';
import { ToastService } from '../core/toast.service';

type Panel = 'pwdSetup' | 'pwdExpiry' | 'approval' | 'smtp' | 'fy' | 'dateFmt' | 'reset';

@Component({
  selector: 'app-essential-settings',
  templateUrl: './essential-settings.component.html'
})
export class EssentialSettingsComponent implements OnInit {
  panel: Panel = 'pwdSetup';
  left = [
    { key: 'pwdSetup', label: 'Password Setup' },
    { key: 'pwdExpiry', label: 'Password Expiry' },
    { key: 'approval', label: 'Member Approval' },
    { key: 'smtp', label: 'SMTP' }
  ];
  right = [
    { key: 'fy', label: 'Financial Year' },
    { key: 'dateFmt', label: 'Date Format' },
    { key: 'reset', label: 'Reset for New Client' }
  ];

  s: any;
  orgs: any[] = [];
  orgId: number;
  smtpPassword = '';
  testTo = '';
  newFy = '';
  dateFmt = '';
  reset = { organizationId: null as number, confirmOrgCode: '', wipeResumes: true, wipeMembers: true, wipeMasters: false };
  factoryText = '';

  constructor(private api: ApiService, public auth: AuthService, private toast: ToastService) {}

  ngOnInit() {
    this.orgId = this.auth.user.organizationId;
    this.api.get<any[]>('/organizations').subscribe(o => this.orgs = o);
    this.load();
  }

  load() {
    this.api.get('/settings', { organizationId: this.orgId }).subscribe(s => {
      this.s = s;
      this.dateFmt = s.dateFormat;
      this.newFy = '';
    }, e => this.toast.err(ApiService.message(e)));
  }

  go(p: string) { this.panel = p as Panel; }
  private done = (r: any) => { this.toast.ok(r.message); this.load(); };
  private fail = (e: any) => this.toast.err(ApiService.message(e));

  savePasswordSetup() { this.api.put('/settings/password-setup', this.s.passwordSetup).subscribe(this.done, this.fail); }

  saveExpiry() {
    this.api.put('/settings/password-expiry', { enabled: this.s.passwordExpiry.enabled, defaultHours: this.s.passwordExpiry.defaultHours })
      .subscribe(this.done, this.fail);
  }

  saveApproval() { this.api.put('/settings/approval', this.s.approval).subscribe(this.done, this.fail); }

  saveSmtp() {
    const body = Object.assign({}, this.s.smtp, { password: this.smtpPassword });
    this.api.put('/settings/smtp', body).subscribe(r => { this.smtpPassword = ''; this.done(r); }, this.fail);
  }

  testSmtp() { this.api.post('/settings/smtp/test', { to: this.testTo }).subscribe(r => this.toast.ok(r.message), this.fail); }

  saveFy() {
    this.api.put('/settings/financial-year', { organizationId: this.orgId, value: this.newFy }).subscribe(r => {
      this.done(r);
      if (this.orgId === this.auth.user.organizationId) { this.auth.refresh().subscribe(); }
    }, this.fail);
  }

  preview(fmt: string) {
    try { return formatDate(new Date(), fmt, 'en-US'); } catch (e) { return ''; }
  }

  saveDateFmt() {
    this.api.put('/settings/date-format', { organizationId: this.orgId, value: this.dateFmt }).subscribe(r => {
      this.done(r);
      if (this.orgId === this.auth.user.organizationId) { this.auth.patch({ dateFormat: this.dateFmt }); }
    }, this.fail);
  }

  resetOrgCode() {
    const o = this.orgs.find(x => x.organizationId === this.reset.organizationId);
    return o ? o.orgCode : '';
  }

  runOrgReset() {
    if (!confirm('This permanently deletes data for ' + this.resetOrgCode() + '. Continue?')) { return; }
    this.api.post('/settings/reset-organization', this.reset).subscribe(r => {
      this.toast.ok(r.message);
      this.reset.confirmOrgCode = '';
    }, this.fail);
  }

  runFactoryReset() {
    if (!confirm('Delete EVERY organization, branch and user? This cannot be undone.')) { return; }
    this.api.post('/settings/factory-reset', { confirm: this.factoryText }).subscribe(r => {
      this.toast.ok(r.message);
      this.auth.logout(false);
    }, this.fail);
  }
}
